export default "/images/d767ba5a3e29fb3f8742aa4d84eb53f9.avif";